const PropTypes = require('prop-types');
const React = require('react');
const UrlHelpers = require('components/shared/url_helpers.js');
const ModalUpsells = require('components/listings/cart/modal_upsells.jsx');
const ModalProductSummary = require('./modal_product_summary.jsx');
const { HashUtil } = require('@reverbdotcom/discovery-ui');

class SuccessModal extends React.Component {
  cartItemForProductId(productId) {
    if (!this.props.cart) { return null; }

    return this.props.cart.cartItemForProductId(productId);
  }

  get directCheckoutCartCount() {
    return HashUtil.getSafely(
      this.props,
      'cart.paymentMethodGroups.direct_checkout.count',
      0,
    );

  }

  renderProducts() {
    return this.props.productIds.map((productId, i) => {
      // only show the actions on the last item row
      const isLast = i === this.props.productIds.length - 1;
      return (
        <ModalProductSummary
          cartItem={this.cartItemForProductId(productId)}
          zeroPercentAffirmFinancing={this.props.zeroPercentAffirmFinancing}
          directCheckoutCartCount={this.directCheckoutCartCount}
          showActions={isLast}
          key={productId}
        />
      );
    });
  }

  renderUpsells() {
    return (
      <div className="add-to-cart-modal-upsells">
        <ModalUpsells
          listingId={this.props.productIds[0]}
          className="mt-2"
        >
          <hr className="mtb-1" />
        </ModalUpsells>
      </div>
    );
  }

  render() {
    return (
      <div className="dialog extra-large-dialog">
        <div className="heading heading--light">
          <h2 className="heading-3 color-green">
            <i className="fa fa-check" /> {this.props.message}
          </h2>
        </div>

        <div className="body">
          {this.renderProducts()}
          {this.renderUpsells()}
          <div className="mt-1 bdt-1 bd--offwhite pt-1 align-center weight-bold style-italic">
            <span>
              {I18n.t('js.reverbGives.tagline')}
            </span>
            <a className="ml-1 icon-r-angle-right color-orange" href="/page/reverb-gives">
              {I18n.t('js.reverbGives.learnMore')}
            </a>
          </div>
        </div>
      </div>
    );
  }
}

SuccessModal.propTypes = {
  productIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  cart: PropTypes.object,
  message: PropTypes.string,
  zeroPercentAffirmFinancing: PropTypes.bool,
};

SuccessModal.defaultProps = {
  zeroPercentAffirmFinancing: false,
};

module.exports = SuccessModal;



// WEBPACK FOOTER //
// ./javascripts/components/listings/cart/success_modal.jsx